/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Rename_SavedInputs */

const vi_irrigation_rename_saved = /** @type {(inputs: Irrigation_Rename_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã đổi tên trạm thành ${i?.name}`)
};

/**

* @param {Irrigation_Rename_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_saved = /** @type {((inputs: Irrigation_Rename_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_saved(inputs)
});